
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("sbCtV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a2ae6f3c25775d01$export$2e2bcd8739ae039);

var $lEdH9 = parcelRequire("lEdH9");

var $k9xE6 = parcelRequire("k9xE6");

var $7u3rk = parcelRequire("7u3rk");

var $jj1EQ = parcelRequire("jj1EQ");

var $5zYYx = parcelRequire("5zYYx");

var $ex6Pq = parcelRequire("ex6Pq");
const $a2ae6f3c25775d01$var$getParentStack = (0, $ex6Pq.withProfiling)(function getParentStack(labelStack) {
    if (!labelStack || labelStack.length <= 1) return null;
    return labelStack.slice(0, labelStack.length - 1);
});
const $a2ae6f3c25775d01$var$getSegmentId = (0, $ex6Pq.withProfiling)(function getSegmentId(labelStack) {
    if (!labelStack) return null;
    const leafLabelStack = labelStack[labelStack.length - 1];
    if ((0, $jj1EQ.isSegmentLabel)(leafLabelStack)) return leafLabelStack.segmentId;
    const parentStack = $a2ae6f3c25775d01$var$getParentStack(labelStack);
    if (!parentStack) return null;
    return getSegmentId(parentStack);
});
const $a2ae6f3c25775d01$var$getParentSegmentId = (0, $ex6Pq.withProfiling)(function getParentSegmentId(labelStack) {
    return $a2ae6f3c25775d01$var$getSegmentId($a2ae6f3c25775d01$var$getParentStack(labelStack));
});
/**
 * Whenever a render happen, all parent segment have timing reported
 * This method tries to reduce that noise
 */ const $a2ae6f3c25775d01$var$removeCascadingParentTimingReport = (0, $ex6Pq.withProfiling)(function removeCascadingParentTimingReport(reactProfilerTimings) {
    const timingIndex = new Map();
    reactProfilerTimings.forEach((timing)=>{
        const segmentId = $a2ae6f3c25775d01$var$getSegmentId(timing.labelStack);
        if (segmentId) {
            const timingArray = timingIndex.get(segmentId) ?? [];
            timingIndex.set(segmentId, timingArray);
            timingArray.push(timing);
        }
    });
    reactProfilerTimings.forEach((timing)=>{
        const parentSegmentId = $a2ae6f3c25775d01$var$getParentSegmentId(timing.labelStack);
        if (parentSegmentId) {
            const parentTimings = timingIndex.get(parentSegmentId);
            const filteredParentTimings = parentTimings?.filter((parentTiming)=>{
                return !(parentTiming.startTime === timing.startTime && parentTiming.actualDuration === timing.actualDuration);
            });
            if (filteredParentTimings) timingIndex.set(parentSegmentId, filteredParentTimings);
            else timingIndex.delete(parentSegmentId);
        }
    });
    return [
        ...timingIndex.values()
    ].flatMap((v)=>v);
});
const $a2ae6f3c25775d01$var$transformReactProfilerTimings = (0, $ex6Pq.withProfiling)(function transformReactProfilerTimings(reactProfilerTimings) {
    const filtered = $a2ae6f3c25775d01$var$removeCascadingParentTimingReport(reactProfilerTimings ?? []);
    const reactProfilerTimingsMap = filtered.reduce((result, { labelStack: labelStack, startTime: startTime, commitTime: commitTime, actualDuration: actualDuration, type: type })=>{
        if (labelStack && type !== 'nested-update') {
            const label = labelStack.map((ls)=>ls.name).join('/');
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            const timing = result.get(label) || {
                labelStack: label,
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 1,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = Math.round(start);
            if (end > timing.endTime) timing.endTime = Math.round(end);
            if (type === 'mount') timing.mountCount += 1;
            if (type === 'update') timing.rerenderCount += 1;
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...reactProfilerTimingsMap.values()
    ];
});
const $a2ae6f3c25775d01$var$createPostInteractionLogPayload = (0, $ex6Pq.withProfiling)(function createPostInteractionLogPayload({ lastInteractionFinish: lastInteractionFinish, reactProfilerTimings: reactProfilerTimings, lastInteractionFinishVCResult: lastInteractionFinishVCResult, postInteractionFinishVCResult: postInteractionFinishVCResult }) {
    const config = (0, $7u3rk.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    const ufoName = (0, $jj1EQ.sanitizeUfoName)(lastInteractionFinish.ufoName);
    const rate = (0, $7u3rk.getPostInteractionRate)(ufoName, lastInteractionFinish.type);
    if (!(0, $lEdH9.default)(rate)) return null;
    const pageVisibilityState = (0, $5zYYx.getPageVisibilityState)(lastInteractionFinish.start, lastInteractionFinish.end);
    if (pageVisibilityState !== 'visible') return null;
    const maxEndTimeFromProfiler = reactProfilerTimings ? Math.max(...reactProfilerTimings.map((t)=>t.commitTime)) : lastInteractionFinish.end;
    const revisedEndTime = Math.round(maxEndTimeFromProfiler);
    const revisedTtai = Math.round(maxEndTimeFromProfiler - lastInteractionFinish.start);
    const lastInteractionFinishStart = Math.round(lastInteractionFinish.start);
    const lastInteractionFinishEnd = Math.round(lastInteractionFinish.end);
    const lastInteractionFinishTTAI = Math.round(lastInteractionFinish.end - lastInteractionFinish.start);
    let lastInteractionFinishVC90 = null;
    let lastInteractionFinishVCClean = false;
    if (lastInteractionFinishVCResult?.['ufo:vc:state']) {
        lastInteractionFinishVCClean = true;
        const lastInteractionFinishVCMetrics = lastInteractionFinishVCResult?.['metrics:vc'];
        lastInteractionFinishVC90 = lastInteractionFinishVCMetrics[90] ?? null;
    }
    let postInteractionFinishVCRatios = {};
    let revisedVC90 = null;
    let postInteractionFinishVCUpdates = [];
    let postInteractionFinishVCClean = false;
    if (postInteractionFinishVCResult?.['ufo:vc:state']) {
        postInteractionFinishVCClean = true;
        postInteractionFinishVCRatios = postInteractionFinishVCResult?.['ufo:vc:ratios'];
        postInteractionFinishVCUpdates = postInteractionFinishVCResult?.['ufo:vc:updates'];
        const postInteractionFinishVCMetrics = postInteractionFinishVCResult?.['metrics:vc'];
        if (typeof lastInteractionFinishVC90 === 'number') revisedVC90 = postInteractionFinishVCMetrics[90] ?? null;
    }
    const lateMutations = postInteractionFinishVCUpdates ? postInteractionFinishVCUpdates.filter((entry)=>entry.time > lastInteractionFinish.end).flatMap(({ time: time, elements: elements })=>Array.from(new Set(elements)).map((element)=>({
                time: time,
                element: element,
                viewportHeatmapPercentage: postInteractionFinishVCRatios[element]
            }))) : [];
    return {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: {
                // basic
                'event:hostname': window.location?.hostname || 'unknown',
                'event:product': config.product,
                'event:schema': '1.0.0',
                'event:source': {
                    name: 'react-ufo/web',
                    version: (0, $k9xE6.getReactUFOVersion)(lastInteractionFinish.type),
                    payloadSource: 'platform'
                },
                'event:region': config.region || 'unknown',
                'experience:key': 'custom.post-interaction-logs',
                postInteractionLog: {
                    lastInteractionFinish: {
                        ...lastInteractionFinish,
                        ufoName: ufoName,
                        start: lastInteractionFinishStart,
                        end: lastInteractionFinishEnd,
                        ttai: lastInteractionFinishTTAI,
                        vc90: lastInteractionFinishVC90,
                        vcClean: lastInteractionFinishVCClean
                    },
                    revisedEndTime: revisedEndTime,
                    revisedTtai: revisedTtai,
                    revisedVC90: revisedVC90,
                    vcClean: postInteractionFinishVCClean,
                    lateMutations: lateMutations,
                    reactProfilerTimings: $a2ae6f3c25775d01$var$transformReactProfilerTimings(reactProfilerTimings)
                }
            }
        }
    };
});
var $a2ae6f3c25775d01$export$2e2bcd8739ae039 = $a2ae6f3c25775d01$var$createPostInteractionLogPayload;

});
parcelRegister("k9xE6", function(module, exports) {

$parcel$export(module.exports, "getReactUFOVersion", () => $f4b8ef60d054ae66$export$6cb92cd4ba1a8ec5);

var $fHpHg = parcelRequire("fHpHg");

var $ex6Pq = parcelRequire("ex6Pq");
const $f4b8ef60d054ae66$export$6cb92cd4ba1a8ec5 = (0, $ex6Pq.withProfiling)(function getReactUFOVersion(interactionType) {
    if (interactionType !== 'page_load' && interactionType !== 'transition') return '1.0.1';
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (!(0, $fHpHg.fg)('enable-react-ufo-payload-segment-compressed')) return '1.0.1';
    return '2.0.0';
});

});

parcelRegister("jj1EQ", function(module, exports) {

$parcel$export(module.exports, "sanitizeUfoName", () => $c4f74f753f98e088$export$e08487ea3ae92adb);
$parcel$export(module.exports, "isSegmentLabel", () => $c4f74f753f98e088$export$1adbaf5c2363e4ae);
$parcel$export(module.exports, "buildSegmentTree", () => $c4f74f753f98e088$export$1569bc0edeecbcd8);
$parcel$export(module.exports, "stringifyLabelStackFully", () => $c4f74f753f98e088$export$caeee352b541de1f);
$parcel$export(module.exports, "labelStackStartWith", () => $c4f74f753f98e088$export$1787b1cd413c7e2);
$parcel$export(module.exports, "optimizeLabelStack", () => $c4f74f753f98e088$export$a0cd72da07c76b4c);

var $ex6Pq = parcelRequire("ex6Pq");
const $c4f74f753f98e088$export$e08487ea3ae92adb = (0, $ex6Pq.withProfiling)(function sanitizeUfoName(name) {
    return name.replace(/_/g, '-');
});
const $c4f74f753f98e088$export$1adbaf5c2363e4ae = (0, $ex6Pq.withProfiling)(function isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
});
const $c4f74f753f98e088$export$1569bc0edeecbcd8 = (0, $ex6Pq.withProfiling)(function buildSegmentTree(labelStacks) {
    const r = {
        n: 'segment-tree-root',
        c: {}
    };
    labelStacks.forEach((labelStack)=>{
        let currentNode = r;
        labelStack.forEach((label)=>{
            const name = label.name;
            const id = $c4f74f753f98e088$export$1adbaf5c2363e4ae(label) ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name
            };
            currentNode = currentNode.c[key];
        });
    });
    return {
        r: r
    };
});
const $c4f74f753f98e088$export$caeee352b541de1f = (0, $ex6Pq.withProfiling)(function stringifyLabelStackFully(labelStack) {
    return labelStack.map((l)=>{
        if ($c4f74f753f98e088$export$1adbaf5c2363e4ae(l)) return `${l.name}:${l.segmentId}`;
        return l.name;
    }).join('/');
});
const $c4f74f753f98e088$var$getLabelStackReference = (0, $ex6Pq.withProfiling)(function getLabelStackReference(labelStack) {
    return labelStack.map((l)=>$c4f74f753f98e088$export$1adbaf5c2363e4ae(l) ? l.segmentId : l.name).join('/');
});
const $c4f74f753f98e088$export$1787b1cd413c7e2 = (0, $ex6Pq.withProfiling)(function labelStackStartWith(labelStack, startWith) {
    return $c4f74f753f98e088$export$caeee352b541de1f(labelStack).startsWith($c4f74f753f98e088$export$caeee352b541de1f(startWith));
});
const $c4f74f753f98e088$export$a0cd72da07c76b4c = (0, $ex6Pq.withProfiling)(function optimizeLabelStack(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? $c4f74f753f98e088$var$getLabelStackReference(labelStack) : labelStack.map((ls)=>({
            n: ls.name,
            ...ls.segmentId ? {
                s: ls.segmentId
            } : {}
        }));
});

});



//# sourceMappingURL=create-post-interaction-log-payload.99d5bd68.js.map
